import { isBrowser } from "../functions/is-browser.qwik.mjs";
import { isFromTrustedHost } from "../functions/is-from-trusted-host.qwik.mjs";
import { setupBrowserForEditing } from "../scripts/init-editing.qwik.mjs";
import { logger } from "./logger.qwik.mjs";
const createEditorListener = ({ model, trustedHosts, callbacks }) => {
  return (event) => {
    if (!isFromTrustedHost(trustedHosts, event))
      return;
    const { data } = event;
    if (data)
      switch (data.type) {
        case "builder.configureSdk":
          callbacks.configureSdk(data.data);
          break;
        case "builder.triggerAnimation":
          callbacks.animation(data.data);
          break;
        case "builder.resetState": {
          const messageContent = data.data;
          const modelName = messageContent.model;
          const newState = messageContent == null ? void 0 : messageContent.state;
          if (modelName === model && newState)
            callbacks.stateUpdate(newState);
          break;
        }
        case "builder.contentUpdate": {
          const messageContent = data.data;
          const key = messageContent.key || messageContent.alias || messageContent.entry || messageContent.modelName;
          const contentData = messageContent.data;
          if (key === model)
            callbacks.contentUpdate(contentData);
          break;
        }
      }
  };
};
const subscribeToEditor = ({ model, apiKey, callback, trustedHosts }) => {
  if (!isBrowser) {
    logger.warn("`subscribeToEditor` only works in the browser. It currently seems to be running on the server.");
    return () => {
    };
  }
  setupBrowserForEditing({
    modelName: model,
    apiKey
  });
  const listener = createEditorListener({
    callbacks: {
      contentUpdate: callback,
      animation: () => {
      },
      configureSdk: () => {
      },
      stateUpdate: () => {
      }
    },
    model,
    trustedHosts
  });
  window.addEventListener("message", listener);
  return () => {
    window.removeEventListener("message", listener);
  };
};
export {
  createEditorListener,
  subscribeToEditor
};
